// extracted by mini-css-extract-plugin
module.exports = {"root":"card_root__123Ya","title":"card_title__3OyET"};